import { GroupAssessment, Page, PageRequest } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GroupAssessmentsResolver {
  private readonly _groupsApi = inject(GroupService);

  resolve(route: ActivatedRouteSnapshot): Observable<Page<GroupAssessment>> {
    const pageRequest = new PageRequest({
      ...route.queryParams,
      offset: 0,
      limit: 30,
    });
    return this._groupsApi.findAllAssessmentsPageByGroupId(
      route.params['id'],
      new PageRequest(pageRequest)
    );
  }
}
